import {
  IonButton,
  IonButtons,
  IonContent,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { QrReader } from "react-qr-reader";

export const QRWebModal = ({ dismiss, set, scan, error }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (data) scan(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <IonPage>
      <IonContent fullscreen scrollY={false}>
        <IonToolbar className={"transparent"} style={{ position: "absolute" }}>
          <IonTitle>Scan</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={dismiss}>Close</IonButton>
          </IonButtons>
        </IonToolbar>
        <QrReader
          constraints={{ facingMode: "environment" }}
          onResult={(result) => {
            if (!!result) {
              setData(result?.text);
            }
          }}
          containerStyle={{ height: "100%", textAlign: "center" }}
          videoContainerStyle={{ height: "100%", textAlign: "center" }}
          videoStyle={{
            height: "100%",
            padding: "0px",
            margin: "0px",
            objectFit: "cover",
          }}
        />
      </IonContent>
    </IonPage>
  );
};
